export enum ProjectPreferenceTime {
  SHORT_TERM = 'SHORT_TERM',
  MID_TERM = 'MID_TERM',
  LONG_TERM = 'LONG_TERM'
}

export const PREFERENCE_TIME_MAP = {
  [ProjectPreferenceTime.SHORT_TERM]: 'Short Term',
  [ProjectPreferenceTime.MID_TERM]: 'Mid Term',
  [ProjectPreferenceTime.LONG_TERM]: 'Long Term'
};